import React, { Component } from 'react';
import PropTypes from 'prop-types';

import css from 'styles/components/productdetail/imageZoom.scss';

class ImageZoom extends Component {
  state = {
    width: 0,
    height: 0,
    src: '',
    hasLoaded: false
  };

  componentDidMount = () => {
    if (this.image && this.image.complete && !this.state.hasLoaded) {
      // If image is cached by browser it won't fire the standard onload event, so we need to manually do it
      this.handleOnLoad();
    }
  };

  handleClick = event => {
    const { lowResImageSrc, hiResImageSrc, onProductImageClick } = this.props;
    const { width, height, hasLoaded } = this.state;
    const mouseCoordinates = { pageX: event.pageX, pageY: event.pageY };
    if (hasLoaded) {
      onProductImageClick(lowResImageSrc, hiResImageSrc, width, height, mouseCoordinates);
    }
  };

  handleOnLoad = () => {
    const { width, height } = this.image;
    this.setState({ width, height, hasLoaded: true });
  };

  makeImg = () => {
    const {
      props: { lowResImageSrc, altText: alt },
      handleOnLoad
    } = this;
    return (
      <img
        src={lowResImageSrc}
        className={css.image}
        alt={alt}
        onLoad={handleOnLoad}
        ref={el => this.image = el} />
    );
  };

  render() {
    const { context: { testId }, handleClick, makeImg, props: { isSpotlightActive } } = this;
    return (
      <button
        type="button"
        className={css.button}
        onClick={handleClick}
        tabIndex={isSpotlightActive ? -1 : 0}
        aria-label="Zoom into product image"
        data-test-id={testId('imageZoom')}>
        {makeImg()}
      </button>
    );
  }
}

ImageZoom.propTypes = {
  lowResImageSrc: PropTypes.string.isRequired,
  hiResImageSrc: PropTypes.string.isRequired,
  altText: PropTypes.string.isRequired,
  onProductImageClick: PropTypes.func.isRequired
};

ImageZoom.contextTypes = {
  testId: PropTypes.func
};

export default ImageZoom;
